<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../components/screen";
import { customerService } from "../../../services/contactservice/customer.service";
import { saleService } from "../../../services/saleservice/sale.service";
import { bookingService } from "../../../services/bookingservice/booking.service";
import Swal from "sweetalert2";
import i18n from "../../../i18n";
import Loader from "../../../components/widgets/loader";
import List from "../../../components/list";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Select from "@/components/c-select";
import Partner from "@/components/c-partner";

/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Customer Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loader, 
    List,
    Input,
    Area,
    Select, 
    Partner
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      title: "Customer",
      breadCrumb: {},
      customerData: null,
      saleData: {},
      bookingData: {},
      idTypeList: {},
      genderList: {},
      nationalityList: {},
      typeList: {},

      attachement: {},
      dataCode: '',
      dataType: 0,
      dataName: '',
      dataNameEn: '',
      dataPhone1: '',
      dataPhone2: '',
      dataEmail: '',
      dataNationality: 0,
      dataGender: 0,
      dataDOB: '',
      dataIDType: 0,
      dataIDNo: '',
      dataIDDate: '',
      dataAddress: '',
      dataAddressEn: '',
      dataPhoto: [],
      dataDoc: [],
      dataPartners: []
    };
  },
  mounted() {
    /* eslint-disable no-console */
    this.loadingData(this.$route.params.id);
    
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      customerService.getOne(id)
        .then(response => {

          this.fetchingStats = true;

          if(response.data) {
            this.breadCrumb = {
              text: response.data.name + " - (" + response.data.code + ")",
              active: true,
            };

            this.customerData = response;

            // this.title = this.customerData.data.name + " - (" + this.customerData.data.code + ")";

            this.dataCode = this.customerData.data.code;
            this.dataType = this.customerData.data.type_id;
            this.dataName = this.customerData.data.name;
            this.dataNameEn = this.customerData.data.name_en;
            this.dataPhone1 = this.customerData.data.phone_no_1;
            this.dataPhone2 = this.customerData.data.phone_no_2;
            this.dataEmail = this.customerData.data.email;
            this.dataNationality = this.customerData.data.nationality_id;
            this.dataGender = this.customerData.data.sex;
            this.dataDOB = this.customerData.data.dob;
            this.dataIDType = this.customerData.data.id_type;
            this.dataIDNo = this.customerData.data.id_no;
            this.dataIDDate = this.customerData.data.id_date;
            this.dataAddress = this.customerData.data.address;
            this.dataAddressEn = this.customerData.data.address_en;
            this.dataPhoto.push(this.customerData.data.photo);

            this.customerData.data.collections.map(item => {
              if('customer_attachments' in item) {
                this.dataDoc = item.customer_attachments.filter(attachment => attachment.path != null);
              } else if('customer_partners' in item) {
                this.dataPartners = item.customer_partners;
              }
            });
          }

          this.loadingSettings(response.setting);
          
        });
    },

    loadingSaleData: function(id) {
      this.fetchingStats = false;
      saleService.getListByCustomer(id)
        .then(response => {

          this.fetchingStats = true;
          this.saleData = response;


        });
    },


    loadingBookingData: function(id) {
      this.fetchingStats = false;
      bookingService.getListByCustomer(id)
        .then(response => {

          console.log(response.data);

          this.fetchingStats = true;
          this.bookingData = response;

        });
    },


    // loadingCustomerAttachmentByCustomerId: function(customerId) {

    //   let param = customerId == 0 ? '?page=0' : `?page=0&clause={"clause":[{"conjuction":"and","customer_attachments.customer_id":{"value":${customerId}}}]}`;

    //   customerattachmentService.getList(param)
    //     .then(response => {
    //       this.attachement = response;
    //     });
    // },

    loadingSettings: function(setting) {

      this.idTypeList = {data: setting.idtypes};
      this.genderList = {data: setting.genders};
      this.nationalityList = {data: setting.nationalities};
      this.typeList  = {data: setting.customertypes};
     
    },

    onBookingTabClicked: function() {
      this.loadingBookingData(this.$route.params.id);
    },
    onSoldTabClicked: function() {
      this.loadingSaleData(this.$route.params.id);
    },
    onHistoryTabClicked: function() {
      // this.loadingSaleData(this.$route.params.id);
    },

    submitCancel: function() {

      Swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "customer-list"
          });

        }
      });

      
    }
  }
};
</script>

<template>
  <Layout>
   <PageHeader :items="[{
        text: $t('customer.list'),
        href: '/general/customer',
      }, this.breadCrumb]" :title="$t('customer.text')" />
    <Loader :loading="fetchingStats">
    <div class="row">
      <div class="col-lg-12">

        <b-tabs content-class="p-3 text-muted">
          <b-tab active class="border-0">
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-user bx-tada font-size-20 align-middle me-2"></i>
                {{$t('customer.general')}}
              </div>
            </template>
            <div class="row">
              <div class="col-lg-8">
                <div class="card">
                  <div class="card-body">
                      <div class="row">
                        <div class="col-md-6">
                          <Input 
                            :type="'text'"
                            :id="'code'"
                            :disabled="true"
                            v-model="dataCode"
                            :label="'customer.code'"
                            /> 
                        </div>
                        <div class="col-md-6">
                          <Select 
                            :id="'type_id'"
                            :list="this.typeList"
                            v-model="dataType"
                            :label="'customer.type'"
                            :disabled="true"
                            /> 
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <Input 
                            :type="'text'"
                            :id="'name'"
                            v-model="dataName"
                            :disabled="true"
                            :label="'customer.name'"  />
                        </div>
                        <div class="col-md-6">
                          <Input 
                            :type="'text'"
                            :id="'name-en'"
                            v-model="dataNameEn"
                            :disabled="true"
                            :label="'customer.name-en'"  />
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-4">
                          <Input 
                            :type="'text'"
                            :id="'phone_no_1'"
                            v-model="dataPhone1"
                            :mask="'### ### ########'"
                            :disabled="true"
                            :label="'customer.phone-no-1'"  />
                        </div>
                        <div class="col-md-4">
                          <Input 
                            :type="'text'"
                            :id="'phone_no_2'"
                            :mask="'### ### ########'"
                            v-model="dataPhone2"
                            :disabled="true"
                            :label="'customer.phone-no-2'"  />
                        </div>
                        <div class="col-md-4">
                          <Input 
                            :type="'text'"
                            :id="'email'"
                            v-model="dataEmail"
                            :disabled="true"
                            :label="'customer.email'"  />
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-lg-4">
                          <Select 
                            :id="'nationality_id'"
                            v-model="dataNationality"
                            :list="this.nationalityList"
                            :disabled="true"
                            :label="'customer.nationality'"  />
                        </div>
                        <div class="col-lg-4">
                          <Select 
                            :id="'sex'"
                            v-model="dataGender"
                            :list="this.genderList"
                            :disabled="true"
                            :label="'customer.gender'"  />
                        </div>

                        <div class="col-lg-4">
                          <Input 
                            :type="'date'"
                            :id="'dob'"
                            :disabled="true"
                            v-model="dataDOB"
                            :label="'customer.dob'"  />
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-lg-4">
                          
                          <Select 
                            :id="'id_type'"
                            v-model="dataIDType"
                            :list="this.idTypeList"
                            :disabled="true"
                            :label="'customer.id-type'"  />
                        </div>
                        <div class="col-lg-4">
                          <Input 
                            :type="'text'"
                            :id="'id_no'"
                            v-model="dataIDNo"
                            :disabled="true"
                            :label="'customer.id-no'"  />
                        </div>
                        <div class="col-lg-4">
                          <Input 
                            :type="'date'"
                            :id="'id_date'"
                            :disabled="true"
                            v-model="dataIDDate"
                            :label="'customer.id-date'"  />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6">
                          <Area 
                            :rows="5"
                            :id="'address'"
                            :disabled="true"
                            v-model="dataAddress"
                            :label="'customer.address'"  />
                        </div>
                        <div class="col-lg-6">
                          <Area 
                            :rows="5"
                            :id="'address_en'"
                            :disabled="true"
                            v-model="dataAddressEn"
                            :label="'customer.address-en'"  />
                        </div>
                      </div>
            
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <Partner v-for="(partner, index) in dataPartners" :key="index" :ref="'partners_' + index"
                  :partner="partner"
                  :disabled="true"
                  :index="index+1"
                  :idTypeData="idTypeList"
                  :nationalityData="nationalityList" 
                  :sexData="genderList"
                />
              </div>
            </div>
          </b-tab>
          <b-tab @click="onBookingTabClicked()">
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-bookmark font-size-20 align-middle me-2"></i>
                {{$t('menuitems.booking.text')}}
              </div>
            </template>
            <List v-bind:dataList="bookingData" 
                v-bind:updating="fetchingStats" 
                v-bind:navigate="pageNavigate"
                v-bind:showNo="false"
                v-bind:formats="[{name: 'booking_date', type: 'date'}, {name: 'booking_amount', type: 'currency', sign: '$'}]"
                v-bind:fields="[ `code: ${$t('booking.code')}`,
                  `property: ${$t('property.text')}`, `booking_date: ${$t('general.date')}`, `booking_amount: ${$t('booking.deposit')}`]"                
                v-bind:filter="{}"
                
            />  
          </b-tab>
          <b-tab @click="onSoldTabClicked()">
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-dollar-circle font-size-20 align-middle me-2"></i>
                {{$t('menuitems.sale.text')}}
              </div>
            </template>
            <List v-bind:dataList="saleData" 
                v-bind:updating="fetchingStats" 
                v-bind:navigate="pageNavigate"
                v-bind:showNo="false"
                v-bind:formats="[{name: 'sale_date', type: 'date'}, {name: 'paid_amount', type: 'currency', sign: '$'}]"
                v-bind:fields="[ `code: ${$t('sale.code')}`,
                  `property: ${$t('property.text')}`, `sale_date: ${$t('general.date')}`, `paid_amount: ${$t('sale.amount')}`]"                
                v-bind:filter="{}"
                
            />  
          </b-tab>
          <!-- <b-tab>
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-book-bookmark font-size-20 align-middle me-2"></i>
                {{$t('menuitems.loan.text')}}
              </div>
            </template>

          </b-tab> -->
          <!-- <b-tab @click="onHistoryTabClicked()">
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-history font-size-20 align-middle me-2"></i>
                {{$t('menuitems.profitlost.list.history')}}
              </div>
            </template>

          </b-tab> -->
          <!-- <b-tab>
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-down-arrow-alt font-size-20 align-middle me-2"></i>
                {{$t('menuitems.profitlost.list.income')}}
              </div>
            </template>

          </b-tab> -->
          <!-- <b-tab>
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx-up-arrow-alt font-size-20 align-middle me-2"></i>
                {{$t('menuitems.profitlost.list.expense')}}
              </div>
            </template>

          </b-tab> -->
          <!-- <b-tab>
            <template v-slot:title>
              <div class="btn-block">
                <i class="bx bx bx-reset font-size-20 align-middle me-2"></i>
                {{$t('menuitems.additionaloperation.list.buyback.text')}}
              </div>
            </template>

          </b-tab> -->
        </b-tabs>

      </div>
    </div>    
    </Loader>
  </Layout>
</template>